import {AMARON__EVENT_CONTAINER__SOURCE__PRIORITY__COLUMN_ID} from "~/domainModels/workspaceSpecific/amaron";

/** Journey/event additional columns stored as numbers but selected in filters as strings. */
const NUMERIC_API_FILTER_COLUMN_IDS: ReadonlySet<string> = new Set([
    AMARON__EVENT_CONTAINER__SOURCE__PRIORITY__COLUMN_ID,
]);

export function isNumericApiFilterColumn(columnId: string): boolean {
    return NUMERIC_API_FILTER_COLUMN_IDS.has(columnId);
}

function coerceNumericFilterScalar(value: unknown): unknown {
    if (typeof value === "number" && Number.isFinite(value)) {
        return value;
    }
    if (typeof value === "string") {
        const trimmed = value.trim();
        if (trimmed === "") {
            return value;
        }
        const parsed = Number(trimmed);
        if (Number.isNaN(parsed) === false) {
            return parsed;
        }
    }
    return value;
}

/** Coerces filter payload values for numeric DB columns (e.g. Amaron Priority score). */
export function coerceFilterLineItemValueForApi(columnId: string, value: unknown): unknown {
    if (isNumericApiFilterColumn(columnId) === false) {
        return value;
    }
    if (Array.isArray(value)) {
        return value.map((entry) => coerceNumericFilterScalar(entry));
    }
    return coerceNumericFilterScalar(value);
}
